/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreInAppInAppValidationRequestFromJSON, FxIdApplicationStoreInAppInAppValidationRequestToJSON, } from './FxIdApplicationStoreInAppInAppValidationRequest';
/**
 * Check if a given object implements the FxIdWebFeaturesNativeInAppValidateInAppRequest interface.
 */
export function instanceOfFxIdWebFeaturesNativeInAppValidateInAppRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('ValidationRequest' in value) || value['ValidationRequest'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesNativeInAppValidateInAppRequestFromJSON(json) {
    return FxIdWebFeaturesNativeInAppValidateInAppRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesNativeInAppValidateInAppRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'ValidationRequest': FxIdApplicationStoreInAppInAppValidationRequestFromJSON(json['ValidationRequest']),
    };
}
export function FxIdWebFeaturesNativeInAppValidateInAppRequestToJSON(json) {
    return FxIdWebFeaturesNativeInAppValidateInAppRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesNativeInAppValidateInAppRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'ValidationRequest': FxIdApplicationStoreInAppInAppValidationRequestToJSON(value['ValidationRequest']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesNativeInAppValidateInAppRequest.js.map